import { render } from "./HandlerOrder.vue?vue&type=template&id=345b8b9e&scoped=true"
import script from "./HandlerOrder.vue?vue&type=script&lang=js"
export * from "./HandlerOrder.vue?vue&type=script&lang=js"

import "./HandlerOrder.vue?vue&type=style&index=0&id=345b8b9e&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345b8b9e"]])

export default __exports__